import ProductComponent from '../components/products/products'

const Products = () => <ProductComponent />

export default Products;